package ui.new_ui.screen_settings

import emotion.react.css
import react.FC
import react.PropsWithChildren
import react.dom.html.ReactHTML
import web.cssom.AlignItems
import web.cssom.Display
import web.cssom.JustifyContent
import web.cssom.pct



val CentredScreenComponent = FC<PropsWithChildren>{
    ReactHTML.div{
        css(className) {
            width = 100.pct
            display = Display.flex
            justifyContent = JustifyContent.center
            alignItems = AlignItems.center
        }
        +it.children
    }
}